/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:28 GMT
 */
const tokens = {
    component: {
        tag: {
            default: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                backgroundColor: {
                    value: "#e6e6e6",
                    type: "color",
                },
            },
            hover: {
                backgroundColor: {
                    value: "#EBEEF2",
                    type: "color",
                },
            },
        },
    },
};
export default tokens;
